export default __webpack_public_path__ + "static/media/subs_logo.a6625a6c.png";